import React from "react";
import { Link } from "react-router-dom";
import { NetoyageData } from "../../../../../api/NetoyagaData";
import SectionTitle from "../../../../Shared/SectionTitle/SectionTitle";

const Category = () => {
  return (
    <div className="wpo-project-area-s2 section-padding">
      <div className="container">
        <SectionTitle MainTitle={"ROOTS"} subTitle={"Nos machines"} />
        <div className="row align-items-center">
          <div className="wpo-project-wrap">
            <div className="sortable-gallery">
              <div className="row">
                <div className="col-lg-12">
                  <div className="project-grids gallery-container clearfix" style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                    {NetoyageData.map((nettgoyage) => (
                      <div className="grid" key={nettgoyage.id} style={{marginRight: "0.5rem", marginLeft:"0.5rem"}}>
                        <Link to={`/others/nettoyage/single/${nettgoyage.id}`}>
                          <div className="wpo-project-item">
                            <div className="wpo-project-img">
                              <img src={nettgoyage.image} alt="" />
                              <div className="left-border"></div>
                              <div className="right-border"></div>
                            </div>
                            <div className="wpo-project-text category-title">
                              <h2>{nettgoyage.title}</h2>
                              {/* <span>{nettgoyage.subTitle}</span> */}
                            </div>
                          </div>
                        </Link>
                        <h3 className="subTitle-category">
                          {nettgoyage.title}
                        </h3>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
